import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="text-2xl font-bold mb-4">ScapeWorx</div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Crafting outdoor excellence since 2009
            </p>
            <div className="flex items-center gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-[#E67E22] hover:text-[#E67E22] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-[#E67E22] hover:text-[#E67E22] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://houzz.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-[#E67E22] hover:text-[#E67E22] transition-colors cursor-pointer">
                <i className="ri-home-4-line text-lg"></i>
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-gray-600 flex items-center justify-center hover:border-[#E67E22] hover:text-[#E67E22] transition-colors cursor-pointer">
                <i className="ri-pinterest-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Landscape Design</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Patios &amp; Hardscaping</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Retaining Walls</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Landscape Lighting</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Drainage Solutions</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Lawn Maintenance</a></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-bold mb-6">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Home</Link></li>
              <li><a href="#about" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">About</a></li>
              <li><a href="#process" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Process</a></li>
              <li><a href="#gallery" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Portfolio</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Testimonials</a></li>
              <li><a href="#faq" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">FAQ</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold mb-6">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#E67E22] text-xl flex-shrink-0"></i>
                <span className="text-gray-400">Glen Mills, PA 19342</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#E67E22] text-xl flex-shrink-0"></i>
                <a href="tel:6105550123" className="text-gray-400 hover:text-[#E67E22] transition-colors text-xl font-semibold cursor-pointer whitespace-nowrap">(610) 555-0123</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#E67E22] text-xl flex-shrink-0"></i>
                <a href="mailto:info@scapeworx.com" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">info@scapeworx.com</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-[#E67E22] text-xl flex-shrink-0"></i>
                <div className="text-gray-400">
                  <div className="whitespace-nowrap">Mon-Fri: 7am-6pm</div>
                  <div className="whitespace-nowrap">Sat: 8am-4pm</div>
                </div>
              </li>
            </ul>
            <a href="#estimate" className="inline-block mt-6 bg-[#E67E22] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#D35400] transition-all whitespace-nowrap cursor-pointer">
              Request Estimate
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-sm text-gray-400">
              © {currentYear} ScapeWorx. All rights reserved.
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line text-[#E67E22]"></i>
              <span className="text-gray-400 whitespace-nowrap">Licensed &amp; Insured in PA</span>
            </div>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-[#E67E22] transition-colors cursor-pointer whitespace-nowrap">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}